export default function BottomFader({ darkMode }) {
    return(
        <span className={`bottom-fader ${ !darkMode ? 'light' : ''}`}></span>
    )
}